module.exports = __webpack_public_path__ + "img/nav04_h.efb9be48.png";